import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const s = {
  page: { minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: 'Arial, sans-serif' },
  header: {
    background: 'linear-gradient(135deg, #2d2d7e 0%, #1a1a5e 100%)',
    color: '#fff', padding: '40px 24px 48px', textAlign: 'center',
  },
  headerIcon: { fontSize: '48px', marginBottom: '12px' },
  headerTitlu: { fontSize: '28px', fontWeight: '700', margin: '0 0 8px' },
  headerSub: { fontSize: '15px', opacity: 0.85, margin: 0 },
  body: { maxWidth: '900px', margin: '0 auto', padding: '32px 16px 64px' },
  grid2: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '16px', marginBottom: '24px' },
  card: { backgroundColor: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  cardTitle: { fontSize: '13px', fontWeight: '700', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '16px' },
  row: { display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' },
  icon: { fontSize: '18px', flexShrink: 0, marginTop: '2px' },
  rowLabel: { fontSize: '12px', color: '#9ca3af', marginBottom: '2px' },
  rowVal: { fontSize: '14px', color: '#1f2937', fontWeight: '500', wordBreak: 'break-word' },
  link: { color: '#2d2d7e', textDecoration: 'none', fontWeight: '500' },
  deptGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '12px', marginBottom: '24px' },
  deptCard: { backgroundColor: '#fff', borderRadius: '10px', padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', borderLeft: '4px solid #2d2d7e' },
  deptNume: { fontSize: '15px', fontWeight: '700', color: '#1f2937', marginBottom: '6px' },
  deptDesc: { fontSize: '13px', color: '#6b7280', marginBottom: '8px', lineHeight: '1.4' },
  deptContact: { fontSize: '13px', color: '#374151' },
  actiuniGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', marginBottom: '24px' },
  actCard: {
    backgroundColor: '#fff', borderRadius: '12px', padding: '20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)', textAlign: 'center',
    textDecoration: 'none', color: 'inherit', display: 'block',
    transition: 'transform 0.1s, box-shadow 0.1s',
    border: '2px solid transparent',
  },
  actIcon: { fontSize: '32px', marginBottom: '10px' },
  actLabel: { fontSize: '14px', fontWeight: '700', color: '#1f2937', marginBottom: '4px' },
  actDesc: { fontSize: '12px', color: '#6b7280' },
  infoBox: {
    backgroundColor: '#eff6ff', border: '1px solid #bfdbfe',
    borderRadius: '10px', padding: '16px 20px', marginBottom: '24px',
  },
  infoTitle: { fontSize: '14px', fontWeight: '700', color: '#1d4ed8', marginBottom: '8px' },
  infoText: { fontSize: '13px', color: '#1e40af', lineHeight: '1.6', margin: 0 },
  tag: {
    display: 'inline-block', backgroundColor: '#dbeafe', color: '#1d4ed8',
    borderRadius: '4px', padding: '2px 8px', fontSize: '12px', fontWeight: '700',
    marginRight: '6px', marginTop: '4px', fontFamily: 'monospace',
  },
  nav: { display: 'flex', justifyContent: 'center', gap: '12px', marginBottom: '32px', flexWrap: 'wrap' },
  navLink: {
    display: 'inline-block', padding: '8px 20px', borderRadius: '8px',
    fontSize: '14px', fontWeight: '600', textDecoration: 'none',
    backgroundColor: 'rgba(255,255,255,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)',
  },
  spinner: { textAlign: 'center', padding: '80px 24px', fontSize: '15px', color: '#6b7280' },
  sectionTitle: { fontSize: '18px', fontWeight: '700', color: '#1f2937', marginBottom: '16px', marginTop: '8px' },
};

function InfoRow({ icon, label, value, href }) {
  if (!value) return null;
  return (
    <div style={s.row}>
      <span style={s.icon}>{icon}</span>
      <div>
        <div style={s.rowLabel}>{label}</div>
        {href
          ? <a href={href} style={s.link} target="_blank" rel="noopener noreferrer">{value}</a>
          : <div style={s.rowVal}>{value}</div>
        }
      </div>
    </div>
  );
}

export default function InfoUtilePage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/util/info-utile')
      .then(r => setData(r.data.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  const p = data?.primarie || {};
  const departamente = data?.departamente || [];

  return (
    <div style={s.page}>
      {/* Header */}
      <div style={s.header}>
        <div style={s.headerIcon}>🏛️</div>
        <h1 style={s.headerTitlu}>{p.nume || 'Primărie'}</h1>
        {p.localitate && <p style={s.headerSub}>{p.localitate}{p.judet ? `, ${p.judet}` : ''}</p>}
        <div style={{ ...s.nav, marginTop: '24px' }}>
          <Link to="/login" style={s.navLink}>Autentificare</Link>
          <Link to="/register" style={s.navLink}>Înregistrare</Link>
          <Link to="/verifica-sesizare" style={s.navLink}>Verifică cerere</Link>
        </div>
      </div>

      <div style={s.body}>

        {loading && <div style={s.spinner}>Se încarcă informațiile...</div>}

        {!loading && (
          <>
            {/* Acțiuni rapide */}
            <p style={s.sectionTitle}>Ce puteți face</p>
            <div style={s.actiuniGrid}>
              {[
                { to: '/register', icon: '📝', label: 'Depune o cerere', desc: 'Înregistrați-vă și depuneți cereri, sesizări sau petiții online' },
                { to: '/verifica-sesizare', icon: '🔎', label: 'Verifică status', desc: 'Urmăriți stadiul unei cereri cu numărul de înregistrare' },
                { to: '/login', icon: '👤', label: 'Contul meu', desc: 'Accesați istoricul cererilor și notificările dvs.' },
              ].map(item => (
                <Link key={item.to} to={item.to} style={s.actCard}>
                  <div style={s.actIcon}>{item.icon}</div>
                  <div style={s.actLabel}>{item.label}</div>
                  <div style={s.actDesc}>{item.desc}</div>
                </Link>
              ))}
            </div>

            {/* Date de contact */}
            <p style={s.sectionTitle}>Date de contact</p>
            <div style={s.grid2}>
              <div style={s.card}>
                <div style={s.cardTitle}>Primărie</div>
                <InfoRow icon="📍" label="Adresă" value={p.adresa} />
                <InfoRow icon="📞" label="Telefon" value={p.telefon} href={p.telefon ? `tel:${p.telefon.replace(/\s/g, '')}` : null} />
                <InfoRow icon="✉️" label="Email" value={p.email} href={p.email ? `mailto:${p.email}` : null} />
                {p.website && (
                  <InfoRow icon="🌐" label="Website" value={p.website}
                    href={p.website.startsWith('http') ? p.website : `https://${p.website}`} />
                )}
                {p.primar && <InfoRow icon="👤" label="Primar" value={p.primar} />}
                {p.cui && <InfoRow icon="🏢" label="CUI" value={p.cui} />}
              </div>

              {p.emailSolicitari && (
                <div style={s.card}>
                  <div style={s.cardTitle}>Solicitări prin email</div>
                  <InfoRow icon="📧" label="Email solicitări" value={p.emailSolicitari}
                    href={`mailto:${p.emailSolicitari}`} />
                  <div style={s.infoBox}>
                    <div style={s.infoTitle}>Cum să scrieți subiectul emailului</div>
                    <p style={s.infoText}>
                      Pentru procesare mai rapidă, includeți tipul solicitării și categoria în subiect:
                    </p>
                    <div style={{ marginTop: '8px' }}>
                      {['SESIZARE', 'RECLAMATIE', 'INFORMATIE', 'PETITIE'].map(t => (
                        <span key={t} style={s.tag}>[{t}]</span>
                      ))}
                    </div>
                    <p style={{ ...s.infoText, marginTop: '8px' }}>
                      Exemplu subiect: <em>[SESIZARE] Groapă în asfalt pe str. Florilor</em>
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Departamente */}
            {departamente.length > 0 && (
              <>
                <p style={s.sectionTitle}>Departamente</p>
                <div style={s.deptGrid}>
                  {departamente.map(d => (
                    <div key={d.id} style={s.deptCard}>
                      <div style={s.deptNume}>{d.nume}</div>
                      {d.descriere && <div style={s.deptDesc}>{d.descriere}</div>}
                      {d.telefon && (
                        <div style={s.deptContact}>
                          📞 <a href={`tel:${d.telefon.replace(/\s/g, '')}`} style={s.link}>{d.telefon}</a>
                        </div>
                      )}
                      {d.email && (
                        <div style={{ ...s.deptContact, marginTop: '4px' }}>
                          ✉️ <a href={`mailto:${d.email}`} style={s.link}>{d.email}</a>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Footer info */}
            <div style={{ ...s.card, textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>
              <p style={{ margin: '0 0 8px' }}>
                Platforma digitală de servicii publice — {p.nume || 'Primărie'}
              </p>
              <p style={{ margin: 0 }}>
                <Link to="/verifica-sesizare" style={s.link}>Verifică status cerere</Link>
                {' · '}
                <Link to="/register" style={s.link}>Înregistrare cont</Link>
                {' · '}
                <Link to="/login" style={s.link}>Autentificare</Link>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
